module.exports = __webpack_public_path__ + "static/sixstories-twitter-010c5359c69cf489ab55c039a363cea1.jpg";